import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'giro-react-toolkit/source/Translation';
import ClassNames from "classnames";

import "./Legend.scss";
import { indexToMinutes } from '../../utilities/CommuteTimes';

/**
 * Component that shows a legend
 */
class Legend extends Component {
   constructor(props) {
      super(props);
      this.onLegendItemSelected = this.onLegendItemSelected.bind(this);
   }

   componentWillMount() {
      this.legendColors = reachMap.legend.colors;
      this.legendOpacity = reachMap.legend.opacity;
   }

   /**
    * Event handler that is called when user selects a commute time
    */
   onLegendItemSelected(index) {
      if ((this.props.canSelectItem) && (this.props.onCommuteTimeSelected))
         this.props.onCommuteTimeSelected(index);
   }

   /**
    * renders the legend component
    */
   render() {
      if (!this.legendColors || !this.legendColors.length)
         return (null);

      var cssClassNames = this.props.className ? "legend " + this.props.className : "legend";

      return (
         <ol className={cssClassNames}>
            {
               this.legendColors.map((item, index) => {
                  const value = indexToMinutes(index, this.props.totalDur);
                  const itemClassNames = ClassNames(
                     "legend-item",
                     {
                        "legend-item--selected": (this.props.selectedTimeIndex === index),
                        "legend-item--selectable": this.props.canSelectItem
                     }
                  );
                  const labelClassNames = ClassNames(
                     "legend-item__label",
                     {
                        "legend-item__label--selectable": this.props.canSelectItem
                     }
                  );

                  return (
                     <li key={value} className={itemClassNames} onClick={() => {
                        this.onLegendItemSelected(index)
                     }}>
                        <div className={labelClassNames}>{value} <Translation resourceKey="ReachMapRes.DurationUnit"/></div>
                        <div className="legend-item__value" style={{ backgroundColor: item, opacity: this.legendOpacity }}></div>
                     </li>
                  );
               })
            }
         </ol>
      );
   }
}

Legend.propTypes = {
   /**
    * defines the legend container css classnames
    */
   className: PropTypes.string,
   /**
    * total duration for the legend scale
    */
   totalDur: PropTypes.number.isRequired,
   /**
    * indicates if legend item selection is enabled (legend items are selectable if statistics option is available)
    */
   canSelectItem: PropTypes.bool,
   /**
    * The selected commute time (correspond à un item de la légende)
    */
   selectedCommuteTime: PropTypes.number,
   /**
    * function to call when a legend item is selected
    */
   onCommuteTimeSelected: PropTypes.func
}

Legend.defaultProps = {
   canSelectItem: false
};


export default Legend;
